/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2023, Zumper
 */

import { selectActiveListings } from '@zcode-ui/perm-address'
import { cn } from '@zcode-ui/shadz-ui'
import { selectIsMobile, selectIsMounted } from '@zcode-ui/web-zumper-global-state'
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectDetailEntityData } from '../../modules/detail/selectors/index'
import {
  buildingPageType,
  listingPageType,
  mapListAFRPageType,
  mapListCFRPageType,
  mapListHFRPageType,
  mapListRFRPageType,
  multiUnitAddressPageType,
  singleUnitAddressPageType,
} from '../../server/utils/determinePageType'
import { getPageType } from '../../utils/getPageType'
import { RenterSurvey } from './RenterSurvey'
import { SURVEY_LINK } from './constants'

const DETAIL_PAGE_TYPES = [
  buildingPageType,
  listingPageType,
  multiUnitAddressPageType,
  singleUnitAddressPageType,
]

const MULTI_UNIT_ADDRESS_PAGE_TYPES = [multiUnitAddressPageType]

const MAPLIST_PAGE_TYPES = [
  mapListAFRPageType,
  mapListCFRPageType,
  mapListHFRPageType,
  mapListRFRPageType,
]

const DETAIL_BOTTOM =
  'max-md:bottom-[calc(var(--chakra-lineHeights-6) + (var(--chakra-space-4) * 2) + 66px)]' // 66px is height of sticky mobile ads

export const RenterSurveyWrapper = () => {
  const location = useLocation()
  const pageType = useSelector((state) => getPageType(state, location))
  const isMobile = useSelector(selectIsMobile)
  const isMaplist = !!pageType && MAPLIST_PAGE_TYPES.includes(pageType)
  const isDetail = !isMaplist && !!pageType && DETAIL_PAGE_TYPES.includes(pageType)
  const isMultiUnitAddress = isDetail && MULTI_UNIT_ADDRESS_PAGE_TYPES.includes(pageType)
  const isDetailTemplate = isDetail && !isMultiUnitAddress
  const isMounted = useSelector(selectIsMounted)
  const activeListings = useSelector(selectActiveListings)
  const detailEntityData = useSelector(selectDetailEntityData)

  const isActive =
    isDetail && !!(isMultiUnitAddress ? activeListings?.length : detailEntityData?.isActive)

  if (!isMounted || (isMobile && (isMaplist || isActive || isDetailTemplate))) {
    return null
  }
  return (
    <div
      className={cn(
        'fixed left-1/2 -translate-x-1/2 z-sticky w-full md:w-[370px] bottom-0',
        isDetail ? DETAIL_BOTTOM : ''
      )}
    >
      <RenterSurvey href={SURVEY_LINK}>Take our survey to win $500</RenterSurvey>
    </div>
  )
}
